import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import AdminRequestAttestDenyModel from "../../Attest/Model/Request/AdminRequestAttestDenyModel";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { ADMIN_PATHS } from "../../config";
import AdminResponseAttestModel from "../../Attest/Model/Response/AdminResponseAttestModel";
import { AttestViews } from "../../Attest/Components/AttestViews";
import useApiCallService from "../../Common/Helpers/ApiCall";
import AdminRequestAttestApprovedModel from "../../Attest/Model/Request/AdminRequestAttestApprovedModel";
import { PendingBankTransferView } from "./PendingBankTransferView";
import AdminResponsePaymentModel from "../Models/Response/AdminResponsePaymentModel";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";


export function PendingBankTransferInfo() {
    const { ApiCall } = useApiCallService();
    const modelId = new URLSearchParams(window.location.search).get('id');
    const model = new URLSearchParams(window.location.search).get('model');
    const paymentId = new URLSearchParams(window.location.search).get('paymentId');
    const amount = new URLSearchParams(window.location.search).get('amount');
    const fromValue = new URLSearchParams(window.location.search).get('from') ?? '';
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);
    // API REQUEST
    const [apiRequestAcceptAttest, setApiRequestAcceptAttest] = useState(new AdminRequestAttestApprovedModel());
    const [apiRequestDenyAttest, setApiRequestDenyAttest] = useState(new AdminRequestAttestDenyModel());

    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('openPayment.infoBankTransfer'));
        setPageTitleKey('openPayment.infoBankTransfer');
        setOnBack(() => {
            navigate(fromValue === "history" ? `${ADMIN_PATHS.BANK_TRANSFERS_HISTORY_LIST}?&paymentId=${paymentId}` : `${ADMIN_PATHS.BANK_TRANSFERS_LIST}?&paymentId=${paymentId}`);
        });
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    //API RESPONSE
    const [apiResponseAttest, setApiResponseAttest] = useState(new AdminResponsePaymentModel());

    const completeSchemaAccept = AdminRequestAttestApprovedModel.getAttributes( null, true);
    const completeSchemaDeny = AdminRequestAttestDenyModel.getAttributes( null, true);

    const [showConfirmModalApprove, setShowConfirmModalApprove] = useState(false);
    const [showConfirmModalDeny, setShowConfirmModalDeny] = useState(false);
    const [error, setError] = useState(false);

    const [errorReason, setErrorReason] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const handleApiResponseAttest  = (apiResponseAttest) => {
            setApiResponseAttest(apiResponseAttest);
        };
        const GetInfoAttest = async () => {

                try {

                    let urlOption =  `/open-payment/admin/payment?id=${paymentId}&modelId=${modelId}&model=${model}`;
                    if(paymentId === null || paymentId === undefined){
                        urlOption = `/open-payment/admin/payment?id=${modelId}`;
                    }
                    const apiCallOptions = {
                        method: "get",
                        url: urlOption,
                    };
                    await ApiCall(apiCallOptions, handleApiResponseAttest );
                } catch (error) {
                    console.log('error', error);
                }
        };
        GetInfoAttest();
    }, [paymentId]);

    // PUT APPROVED
    const handleValidation = async (type) => {
        try {
            if (type === "approve") {
                await completeSchemaAccept.validate(apiRequestAcceptAttest, { abortEarly: false });
            } else {
                await completeSchemaDeny.validate(apiRequestDenyAttest, { abortEarly: false });
            }
            const apiCallOptions = {
                method: type === "approve" ? "put" : "delete",
                url: "/attest/admin",
                data: type === "approve" ? apiRequestAcceptAttest : apiRequestDenyAttest,
            };
            try {
                await ApiCall(apiCallOptions, setApiResponseAttest, setErrorMessage);
                if (type === "approve") {
                    FlashMessage(t('validationMessage.attestApproved'), 'flash-messageSuccess');
                    setShowConfirmModalApprove(false);
                } else {
                    setShowConfirmModalDeny(false);
                    FlashMessage(t('validationMessage.attestDenied'), 'flash-messageSuccess');
                }
            } catch (error) {
                console.log(error);
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            }
        } catch (err) {
            setErrorReason(true);
            console.log(err)
        }
    }

    const handleChangeAttest = () => {
        setApiRequestAcceptAttest((prevFormData) => ({
            ...prevFormData,
            id: apiResponseAttest.id,
            attested: true,
        }))
    }

    // HANDLE DENY
    const handleChangeAttestDenyId = (id) => {
        setApiRequestDenyAttest((prevFormData) => ({
            ...prevFormData,
            id: id,
        }))
    }

    // HANDLE DENY REASON
    const handleChangeAttestDenyReason = (e) => {
        if (e && e.target && e.target.value && e.target.value !== "") {
            setApiRequestDenyAttest((prevFormData) => ({
                ...prevFormData,
                reason: e.target.value,
            }))
            setErrorReason(false);
        } else {
            setErrorReason(true);
        }
    }

    // ERROR MESSAGES
    useEffect(() => {
        if (errorMessage !== '') {
            if (errorMessage === 'InsufficientBalance') {
                FlashMessage(t('validationMessage.insufficientBalance'), 'flash-messageError');
            }
            if (errorMessage === 'UserNeedBankAccount') {
                FlashMessage(t('validationMessage.notAccount'), 'flash-messageError');
            }
            setError(true);
            setApiResponseAttest(new AdminResponsePaymentModel());
            setTimeout(() => {
                CustomReload();
            }, 2000);
        }
    }, [errorMessage]);

    return (
        <>
            {!isMobile && (
                <Col lg={1}>
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'ms-3 mb-3'}
                        onClick={() => {
                            navigate(fromValue === "history" ? `${ADMIN_PATHS.BANK_TRANSFERS_HISTORY_LIST}?&paymentId=${paymentId}` : `${ADMIN_PATHS.BANK_TRANSFERS_LIST}?&paymentId=${paymentId}`);
                        }}
                    />
                </Col>
            )}
            {(apiResponseAttest !== null && apiResponseAttest.id !== '') || (apiResponseAttest !== null && error === true) ?
                <PendingBankTransferView data={apiResponseAttest} onChange={handleChangeAttest} onValidate={handleValidation} onChangeDenyId={handleChangeAttestDenyId} onchangeDenyReason={handleChangeAttestDenyReason} setErrorReason={setErrorReason} errorReason={errorReason} setShowConfirmModalApprove={setShowConfirmModalApprove} showConfirmModalApprove={showConfirmModalApprove} setShowConfirmModalDeny={setShowConfirmModalDeny} showConfirmModalDeny={showConfirmModalDeny} amount={amount}  model={model}/>
                : ''}

        </>
    );

}